import { Helmet } from 'react-helmet'
import MainHeader from '../../components/MainHeader'
import MainFooter from '../../components/MainFooter'
import { motion } from "framer-motion";

import './About.css'
import './MAbout.css'
import { boxvar2, boxvar2_1, boxvar2_2, boxvar2_3 } from '../../core.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import pb_david from '../../assets/pictures/pb_david.webp'


export default function About() {

    return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={"about"} disableanimation={false} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>Über ToN</title>
                <meta property="og:title" content="Über uns" />
                <meta property="og:description" content="Erfahre mehr über die Vision und Geschichte hinter ToNetwork" />
                <meta name="description" content="Erfahre mehr über die Vision und Geschichte hinter ToNetwork" />
            </Helmet>
            <section className='sec_next' id='sec_next--about'>
                <div className='sec_next_cont' id="sec_next--about--cont" style={{ wordBreak: "break-word" }}>

                    <motion.div variants={boxvar2_1} className='about_section_cont' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h2>🚀 Be different. Unleash your creativity.</h2>
                        <h3>ToNetwork ist dein persönlicher Partner für die digitale Welt.</h3>
                        <p>
                            Wir sind nicht einfach nur ein Softwareunternehmen – wir sind Entwickler, Content Creator, AI-Enthusiasten, Designer, Technikfreaks.
                            Und wir bringen all das <b>All-in-One in dein Projekt</b>.<br />
                            Ob App, Webseite, AI-Integration oder ein virales Video – bei uns entsteht alles aus einer Hand. Mit Leidenschaft, Verstand und einem feinen Gespür für das, was morgen wichtig ist.
                        </p>
                    </motion.div>

                    <motion.div variants={boxvar2_2} className='about_section_cont' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h2>🌍 Wer wir sind</h2>
                        <p>
                            Wir sind ein junges Team aus dem Allgäu mit einer einfachen Überzeugung: Digitalisierung
                            sollte nicht kompliziert sein. Deshalb sind wir euer fester Ansprechpartner
                            – von der ersten Idee bis lange nach dem Launch. Wir hosten in Deutschland,
                            setzen auf Open Source und unterstützen gerne soziale Projekte und
                            Vereine.
                        </p>
                        <p>
                            Unsere Kompetenzen reichen von Appentwicklung und Webdesign über Cloudlösungen, KI-basierte Optimierung bis hin zu Videoproduktion, Elektronik und Grafikdesign. Was uns besonders macht:
                            Wir denken ganzheitlich und handeln pragmatisch. Von der ersten Idee bis zum fertigen Produkt.
                        </p>

                    </motion.div>

                    <motion.div variants={boxvar2_3} className='about_section_cont' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h2>🔧 Was wir tun</h2>
                        <p>
                            Unsere Projekte? Vielfältig. Unser Fokus? Glasklar: Zukunft bauen.
                        </p>

                        <h3>Eigene Produkte</h3>
                        <p>
                            Wir entwickeln eigene Plattformen, Apps und digitale Tools, mit denen wir kreative Visionen realisieren und testen, was technisch möglich ist.
                        </p>

                        <h3>Kundenprojekte</h3>
                        <p>
                            Wir arbeiten für Startups, KMUs und Organisationen, die Digitalisierung richtig anpacken wollen.
                            Individuell entwickelt – nie von der Stange.
                        </p>

                        <h3>Unsere Leistungen im Überblick:</h3>
                        <ul>
                            <li>App- und Webentwicklung</li>
                            <li>Cloud- & Serverlösungen</li>
                            <li>KI-gestützte Prozessoptimierung</li>
                            <li>Content Creation & Medienproduktion</li>
                            <li>UI/UX-Design & Branding</li>
                            <li>Elektronikprototypen & smarte Lösungen</li>
                        </ul>

                    </motion.div>

                    <motion.div variants={boxvar2} className='about_section_cont' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h2>💡 Warum ToNetwork?</h2>

                        <h3>Weil du bei uns alles bekommst – aus einer Hand.</h3>

                        <p>
                            Wir kombinieren Technik, Kreativität und Strategie zu einem stimmigen Gesamtpaket.
                            Das Ergebnis: Lösungen, die nicht nur funktionieren, sondern begeistern.
                            Und mit unserer eigens entwickelten Software sorgen wir dafür, dass du sowohl nach außen als auch intern optimal aufgestellt bist.
                        </p>

                        <h3>ToNetwork steht für:</h3>

                        <ul>
                            <li>Maßgeschneiderte Lösungen</li>

                            <li>langfristige Partnerschaft</li>

                            <li>Direkte Kommunikation</li>

                            <li>Persönliche Betreuung</li>

                            <li>Zukunftsorientierte Technologien</li>

                            <li>Leidenschaft für jedes Detail</li>
                        </ul>

                    </motion.div>

                    <motion.div variants={boxvar2} className='about_section_cont' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h2>📖 Unsere Geschichte</h2>
                        <p>
                            ToNetwork wurde im Februar 2021 zum 19. Geburtstag unseres Gründers David Heidl gegründet. Doch die Idee reicht weiter zurück.
                        </p>
                        <p>
                            Bereits 2017 entstand der erste Prototyp einer Webseite unter dem Namen „Testobjekt Networks“ – aus purer Neugier und Spaß an der Sache. Die Begeisterung für Technik zeigte sich früh:
                            Vom eigenen Minecraft-Server mit selbstgeschriebenen Java-Plugins über RaspberryPi-Webserver bis zu Arduino-Elektronikprojekten – der Weg war klar.
                        </p>
                        <p>
                            Heute ist diese Leidenschaft das Fundament für unsere Arbeit. Was als Experiment begann, ist heute ein wachsendes Unternehmen – und die besten Kapitel liegen noch vor uns.
                        </p>

                    </motion.div>

                    <motion.div variants={boxvar2} className='about_section_cont' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h2>👤 Über unseren Gründer</h2>
                        <h3>David Heidl – Technikliebhaber, Visionär, Allrounder.</h3>

                        <div className='team_cont'>
                            <img src={pb_david} className='team_pb' alt='Unser Gründer: David Heidl' />
                            <div className='team_links'>
                                <a href='https://www.linkedin.com/in/david-adrian-heidl/' target='_blank'><FontAwesomeIcon icon={faLinkedin} /> David A Heidl</a>
                                <a href='https://instagram.com/davidfilmt' target='_blank'><FontAwesomeIcon icon={faInstagram} /> @davidfilmt</a>
                                <a href='https://davidfilmt.de' target='_blank' rel='noopener noreferrer'><FontAwesomeIcon icon={faGlobe} /> davidfilmt.de</a>
                            </div>
                        </div>
                        <p>
                            <i>„Ich glaube daran, dass man nur durch ein breites Verständnis wirklich gute Lösungen entwickeln kann – dabei darf man aber nie den Blick fürs Wesentliche verlieren.“</i>
                        </p>
                        <p>
                            Mit einem Faible für Webdesign, Fotografie, Autos, KI und Media.
                            2023 schloss er sein duales Studium in Wirtschaftsinformatik beim ADAC e.V. ab. Seitdem liegt sein Fokus neben der Softwareentwicklung auf KI-Integration und Medienproduktion.
                        </p>

                    </motion.div>
                </div>
            </section >

            <MainFooter />
        </div >
    )
}